import { render, staticRenderFns } from "./IndividualDataTableUserModalContent.vue?vue&type=template&id=00706d08&scoped=true&"
import script from "./IndividualDataTableUserModalContent.vue?vue&type=script&lang=ts&"
export * from "./IndividualDataTableUserModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./IndividualDataTableUserModalContent.vue?vue&type=style&index=0&id=00706d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00706d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VOverlay,VProgressCircular,VRow})
